module.exports = __webpack_public_path__ + "img/utne.63315a1e.png";